module.exports = __webpack_public_path__ + "static/img/6.429ad70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/jpg/6.jpg
// module id = pH9e
// module chunks = 1